import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { SaveScreenDialogOpenParam } from './save-screen-dialog.view-model';

@Injectable()
export class SaveScreenDialogService {

    open$: Subject<any> = new Subject();

    constructor() { }

    open(param: SaveScreenDialogOpenParam) {
        this.open$.next(param);
    }
}
